import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "go-top" }

import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import HeaderComponent from "./components/layout/HeaderComponent.vue";
import PreLoaderComponent from "./components/layout/PreLoaderComponent.vue";
import FooterComponent from "./components/layout/FooterComponent.vue";
import { formationStore } from "./store/formations";
import { useAuthStore } from "./store/user";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isLoading = ref(false);
const currentUrl = ref();
const route = useRoute();
const fstore = formationStore()
const ustore = useAuthStore()
const toTopFunction = () => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
};

onMounted(async () => {
  await
    await fstore.retrieveAllFormation()
  await ustore.checkAuth()
})
watch(route, () => {
  currentUrl.value = route.fullPath;

  isLoading.value = true;
  setTimeout(() => {
    isLoading.value = false;
  }, 1500);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(HeaderComponent),
    _withDirectives(_createVNode(PreLoaderComponent, null, null, 512), [
      [_vShow, isLoading.value]
    ]),
    _createVNode(_component_router_view),
    _createVNode(FooterComponent),
    _createElementVNode("button", {
      bottom: "50px",
      right: "50px",
      onClick: toTopFunction
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_vue_feather, { type: "arrow-up" })
      ])
    ])
  ]))
}
}

})